import { DocumentStoreType } from "client/Api/Documents/common";
import { environmentHttpClient } from "client/Api/httpClient";

export interface DocumentsCommonSettingsModel {
	isAdmin: boolean;
	maxNumberOfFilesToDownloadAsZip: number;
	defaultLayout: DocumentLayoutKind;
}

export interface IDocumentStoreSettingsModel {
	storeType: DocumentStoreType;
}

export enum DocumentStoreInitializationState {
	NotConfigured = 0,
	InProgress = 1,
	Success = 2,
	Failed = 3,
	NoLicense = 4
}

export interface IDocumentStoreInitializationModel {
	storeType: DocumentStoreType;
	state: DocumentStoreInitializationState;
}

export function checkIsDmsInitialized(
	urlQueryString?: string,
	signal?: AbortSignal
): Promise<readonly IDocumentStoreInitializationModel[]> {
	return environmentHttpClient.get<readonly IDocumentStoreInitializationModel[]>(
		"Documents/CheckIsDMSInitialized" + (urlQueryString || ""),
		undefined,
		{ signal }
	);
}

export enum DocumentLayoutKind {
	List = 0,
	Grid = 1
}

export function setLayout(
	viewKind: DocumentLayoutKind,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		"Documents/RegisterDefaultView",
		viewKind,
		{ signal }
	);
}
